"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROTECTED_SUBDOMAINS = void 0;
exports.PROTECTED_SUBDOMAINS = ['dev', 'test', 'hosted', 'api', 'apidev', 'apitest', 'apistage'];
//# sourceMappingURL=subdomains.js.map